/* eslint-disable @typescript-eslint/ban-types */
/* eslint-disable no-use-before-define */
import { keepPreviousData, queryOptions, useQuery } from '@tanstack/react-query';
import { useAccountParams } from '~/hooks/useAccountParams';
import { customFetch } from '~/utils/customFetch';
import useSessionPlQuery from '../useSessionPlQuery';
import { getClientInfo } from './getClientInfo';

export const getClientPlQueryOptions = (id: string | number | undefined) => {
  return queryOptions({
    queryKey: getClientPlQueryKey({
      id,
      isPartner: false,
    }),
    queryFn: () => getClientInfo({ id, fetcher: customFetch }),
    placeholderData: keepPreviousData,
    staleTime: 1000 * 60 * 5, // 5 minutes
    refetchOnWindowFocus: false,
    enabled: !!id,
  });
};

export const getClientPlQueryKey = ({
  id,
  isPartner,
}: {
  id?: number | string;
  isPartner?: boolean | undefined;
}) => ['client.pl', isPartner, String(id)] as const;
export type ResolvedClientPlData = Awaited<ReturnType<typeof getClientInfo>>;
export default function useClientPlQuery<TData = ResolvedClientPlData>(
  select?: (data: ResolvedClientPlData) => TData,
) {
  const accountParams = useAccountParams();
  const { data: sessionData, isFetching } = useSessionPlQuery();
  const clientId = accountParams?.accountId ?? sessionData?.id;
  const useUrlAccount = accountParams != null && accountParams.accountType === 'client';
  const query = useQuery({
    ...getClientPlQueryOptions(clientId),
    select,
    enabled: useUrlAccount
      ? !!clientId
      : !!sessionData && sessionData?.isPartner === false && !isFetching,
  });

  return query;
}
